import { render, staticRenderFns } from "./send_verificationCode.vue?vue&type=template&id=c766417a&scoped=true"
import script from "./send_verificationCode.vue?vue&type=script&lang=js"
export * from "./send_verificationCode.vue?vue&type=script&lang=js"
import style0 from "./send_verificationCode.vue?vue&type=style&index=0&id=c766417a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c766417a",
  null
  
)

export default component.exports